import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.7",
  "description": "Turborepo 1.7은 작업에 더 많은 명확성을 제공하여 개발자 경험을 개선하는 데 중점을 둡니다.",
  "date": "2023/01/11",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.7은 작업에 더 많은 명확성을 제공하여 개발자 경험을 개선하는 데 중점을 둡니다:"
  }, {
    "heading": "",
    "content": "장기 실행 작업에 대한 개선된 지원: persistent: true를 사용하여 종료되지 않는 작업을 표시하여 turbo가 종속성이 있는 경우 경고할 수 있습니다."
  }, {
    "heading": "",
    "content": "출력에 대한 더 나은 명확성: 이제 항상 작업 출력을 선언해야 하므로 작업이 캐시할 내용에 대한 투명성이 향상됩니다."
  }, {
    "heading": "",
    "content": "전역 설치 가능: 한 번 설치하고 어디서나 사용하세요. Turborepo는 이제 전역으로 설치할 수 있으며 저장소 루트뿐만 아니라 모든 디렉토리에서 실행할 수 있습니다."
  }, {
    "heading": "",
    "content": "\"오류만\" 출력 모드: 작업이 실패할 때만 표시하도록 출력 로그를 조용하게 만듭니다."
  }, {
    "heading": "",
    "content": "npm install turbo@latest를 실행하거나 전역으로 설치 NEW하고 set-default-outputs codemod를 실행하여 오늘 업데이트하세요."
  }, {
    "heading": "자신있게-장기-실행-작업-예약",
    "content": "실행되지 않는 작업을 초래할 수 있는 잘못된 구성을 방지하기 위해 이제 persistent: true 구성 옵션을 사용하여 자체적으로 종료되지 않는 작업(dev 스크립트 등)에 대해 Turborepo에 알릴 수 있습니다. 이 구성이 작업에 설정되면 Turborepo는 다른 작업이 이 작업에 종속될 수 없도록 보장합니다. 이는 dev 작업이나 --watch 플래그가 있는 테스트 러너에 유용합니다."
  }, {
    "heading": "자신있게-장기-실행-작업-예약",
    "content": "이전에는 작업 B가 persistent 작업 A에 종속된 경우 작업 A가 종료되지 않았기 때문에 작업 B는 실행되지 않았습니다. 작업 A를 persistent로 선언하면 Turborepo가 이 오류 시나리오가 발생하지 않도록 방지합니다."
  }, {
    "heading": "자신있게-장기-실행-작업-예약",
    "content": "이 릴리스 이전에는 persistent 작업에 대해 turbo run <task> --parallel 사용을 권장해 왔습니다. --parallel을 사용하면 turbo가 종속성 그래프를 무시하고 모든 작업을 한 번에 실행합니다."
  }, {
    "heading": "자신있게-장기-실행-작업-예약",
    "content": "--parallel이 유용한 탈출구를 제공했지만 사용자는 작업이 무엇인지 선언하는 대신 Turborepo에 작업을 어떻게 실행할지 알려야 했습니다."
  }, {
    "heading": "자신있게-장기-실행-작업-예약",
    "content": "전체 토폴로지 종속성 그래프를 버리는 대신 Turborepo가 종속성 그래프를 유지하면서 persistent: true로 종료되지 않는 프로세스에 종속되지 않도록 보장하는 것이 훨씬 더 정확합니다."
  }, {
    "heading": "전역-turbo",
    "content": "turbo를 전역으로 설치하면 프로젝트의 어디에서나 Turborepo 작업을 실행할 수 있습니다. 이를 위해 다음을 사용하세요:"
  }, {
    "heading": "전역-turbo",
    "content": "turbo는 이제 모든 프로젝트에서 작동합니다. 로컬 turbo 버전을 찾기 위해 turbo는 현재 디렉토리에서 항상 위쪽으로 몇 가지 단계를 거칩니다:"
  }, {
    "heading": "전역-turbo",
    "content": "가장 가까운 turbo.json을 찾습니다."
  }, {
    "heading": "전역-turbo",
    "content": "찾지 못하면 workspaces 속성이 있는 첫 번째 package.json을 찾습니다."
  }, {
    "heading": "전역-turbo",
    "content": "찾지 못하면 첫 번째 package.json을 찾습니다."
  }, {
    "heading": "전역-turbo",
    "content": "전역으로 설치된 turbo 버전은 로컬로 설치된 turbo 버전이 존재하지 않거나 찾을 수 없는 경우에만 사용됩니다."
  }, {
    "heading": "전역-turbo",
    "content": "turbo --version 및 turbo bin은 작업을 실행할 turbo 사본의 버전과 바이너리 위치를 각각 표시합니다.\n또한 -vv 또는 --verbosity=2로 실행하면 로컬 또는 전역 turbo가 사용되는지 항상 표시됩니다."
  }, {
    "heading": "명확성-향상을-위해-outputs-선언",
    "content": "이전에는 작업에 대한 outputs 키를 지정하지 않으면 Turborepo가 자동으로 dist/ 및 build/ 디렉토리의 모든 파일을 캐시하려고 시도했습니다."
  }, {
    "heading": "명확성-향상을-위해-outputs-선언",
    "content": "이는 특정 프레임워크의 build 작업에는 잘 작동했지만 이 암시적 동작은 모든 작업에 적용되므로 잘 확장되지 않았습니다. Turborepo를 사용하는 많은 개발자, 팀, 프로젝트 및 코드베이스에서 dist/ 및 build/ 디렉토리를 자동으로 캐시하는 가정이 사용자에게 문제를 일으키고 있다는 것을 발견했습니다."
  }, {
    "heading": "명확성-향상을-위해-outputs-선언",
    "content": "버전 1.7에서는 이 동작이 제거되었으며 이제 turborepo에 캐시할 내용을 명시적으로 알려야 합니다."
  }, {
    "heading": "명확성-향상을-위해-outputs-선언",
    "content": "1.7 미만 버전의 Turborepo에서 기본 캐시 출력에 의존하고 있었다면 @turbo/codemod set-default-outputs codemod를 실행하여 동일한 동작을 얻을 수 있습니다:"
  }, {
    "heading": "명확성-향상을-위해-outputs-선언",
    "content": "또한 아무것도 캐시하지 않는 것이 이제 기본 동작이므로 더 이상 outputs: []를 지정할 필요가 없습니다. codemod는 작업에서 이 구성도 제거합니다."
  }, {
    "heading": "더-조용한-로그를-위한-오류만-출력-모드",
    "content": "오류에 대한 가시성을 제공하기 위해 커뮤니티 멤버 @dobesv가 작업 실행의 모든 로그 대신 오류만 표시하는 솔루션을 기여했습니다. 파이프라인을 디버깅하는 동안 --output-logs=errors-only를 사용하여 신호 대 잡음비를 높게 유지하여 파이프라인의 성공적인 실행을 보장하는 데 집중할 수 있습니다.\n이는 구성 옵션 또는 CLI 플래그로 사용할 수 있습니다"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo v1.6을 출시하고 Turbopack과 병합한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "18.7k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 750k"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 30년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
  }],
  "headings": [{
    "id": "자신있게-장기-실행-작업-예약",
    "content": "자신있게 장기 실행 작업 예약"
  }, {
    "id": "전역-turbo",
    "content": "전역 turbo"
  }, {
    "id": "명확성-향상을-위해-outputs-선언",
    "content": "명확성 향상을 위해 outputs 선언"
  }, {
    "id": "더-조용한-로그를-위한-오류만-출력-모드",
    "content": "더 조용한 로그를 위한 \"오류만\" 출력 모드"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import __img0 from "./../../public/images/blog/turbo-1-7-0/turbo-inference.png";
import {Tabs, Tab} from '../../components/tabs';
import {Badge} from '#components/badge';
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#자신있게-장기-실행-작업-예약",
  title: _jsx(_Fragment, {
    children: "자신있게 장기 실행 작업 예약"
  })
}, {
  depth: 2,
  url: "#전역-turbo",
  title: _jsxs(_Fragment, {
    children: ["전역 ", _jsx("code", {
      children: "turbo"
    })]
  })
}, {
  depth: 2,
  url: "#명확성-향상을-위해-outputs-선언",
  title: _jsxs(_Fragment, {
    children: ["명확성 향상을 위해 ", _jsx("code", {
      children: "outputs"
    }), " 선언"]
  })
}, {
  depth: 2,
  url: "#더-조용한-로그를-위한-오류만-출력-모드",
  title: _jsx(_Fragment, {
    children: "더 조용한 로그를 위한 \"오류만\" 출력 모드"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    img: "img",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.7"
    }), "\n", "\n", _jsx(Date, {
      children: "Wednesday, January 11th, 2023"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar', 'chrisolszewski', 'nicholasyang']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.7은 작업에 더 많은 명확성을 제공하여 개발자 경험을 개선하는 데 중점을 둡니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#schedule-your-long-running-tasks-with-confidence",
          children: _jsx(_components.strong, {
            children: "장기 실행 작업에 대한 개선된 지원"
          })
        }), ": ", _jsx(_components.code, {
          children: "persistent: true"
        }), "를 사용하여 종료되지 않는 작업을 표시하여 ", _jsx(_components.code, {
          children: "turbo"
        }), "가 종속성이 있는 경우 경고할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#declare-your-outputs-for-improved-clarity",
          children: _jsx(_components.strong, {
            children: "출력에 대한 더 나은 명확성"
          })
        }), ": 이제 항상 작업 출력을 선언해야 하므로 작업이 캐시할 내용에 대한 투명성이 향상됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#global-turbo",
          children: _jsx(_components.strong, {
            children: "전역 설치 가능"
          })
        }), ": 한 번 설치하고 어디서나 사용하세요. Turborepo는 이제 전역으로 설치할 수 있으며 저장소 루트뿐만 아니라 모든 디렉토리에서 실행할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#errors-only-output-mode-for-quieter-logs",
          children: _jsx(_components.strong, {
            children: "\"오류만\" 출력 모드"
          })
        }), ": 작업이 실패할 때만 표시하도록 출력 로그를 조용하게 만듭니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "를 실행하거나 ", _jsx(_components.a, {
        href: "#global-turbo",
        children: "전역으로 설치"
      }), " ", _jsx(Badge, {
        children: "NEW"
      }), "하고 ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#set-default-outputs",
        children: _jsx(_components.code, {
          children: "set-default-outputs"
        })
      }), " codemod를 실행하여 오늘 업데이트하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "자신있게-장기-실행-작업-예약",
      children: "자신있게 장기 실행 작업 예약"
    }), "\n", _jsxs(_components.p, {
      children: ["실행되지 않는 작업을 초래할 수 있는 잘못된 구성을 방지하기 위해 이제 ", _jsx(_components.code, {
        children: "persistent: true"
      }), " ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: "구성 옵션"
      }), "을 사용하여 자체적으로 종료되지 않는 작업(", _jsx(_components.code, {
        children: "dev"
      }), " 스크립트 등)에 대해 Turborepo에 알릴 수 있습니다. 이 구성이 작업에 설정되면 Turborepo는 다른 작업이 이 작업에 종속될 수 없도록 보장합니다. 이는 ", _jsx(_components.code, {
        children: "dev"
      }), " 작업이나 ", _jsx(_components.code, {
        children: "--watch"
      }), " 플래그가 있는 테스트 러너에 유용합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t\"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t\t\"dev\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+\t\t\t\"persistent\": true"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t\t}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이전에는 ", _jsx(_components.code, {
        children: "작업 B"
      }), "가 persistent ", _jsx(_components.code, {
        children: "작업 A"
      }), "에 종속된 경우 ", _jsx(_components.code, {
        children: "작업 A"
      }), "가 종료되지 않았기 때문에 ", _jsx(_components.code, {
        children: "작업 B"
      }), "는 실행되지 않았습니다. ", _jsx(_components.code, {
        children: "작업 A"
      }), "를 ", _jsx(_components.code, {
        children: "persistent"
      }), "로 선언하면 Turborepo가 이 오류 시나리오가 발생하지 않도록 방지합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이 릴리스 이전에는 persistent 작업에 대해 ", _jsx(_components.code, {
        children: "turbo run <task> --parallel"
      }), " 사용을 권장해 왔습니다. ", _jsx(_components.code, {
        children: "--parallel"
      }), "을 사용하면 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 종속성 그래프를 무시하고 모든 작업을 한 번에 실행합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--parallel"
      }), "이 유용한 탈출구를 제공했지만 사용자는 작업이 ", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "무엇인지"
        })
      }), " 선언하는 대신 Turborepo에 작업을 ", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "어떻게"
        })
      }), " 실행할지 알려야 했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["전체 토폴로지 종속성 그래프를 버리는 대신 Turborepo가 종속성 그래프를 유지하면서 ", _jsx(_components.code, {
        children: "persistent: true"
      }), "로 종료되지 않는 프로세스에 종속되지 않도록 보장하는 것이 훨씬 더 정확합니다."]
    }), "\n", _jsxs(_components.h2, {
      id: "전역-turbo",
      children: ["전역 ", _jsx(_components.code, {
        children: "turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "를 전역으로 설치하면 프로젝트의 어디에서나 Turborepo 작업을 실행할 수 있습니다. 이를 위해 다음을 사용하세요:"]
    }), "\n", _jsxs(Tabs, {
      items: ["npm", "yarn", "pnpm"],
      storageKey: "selected-pkg-manager",
      children: [_jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " global"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "는 이제 모든 프로젝트에서 작동합니다. 로컬 ", _jsx(_components.code, {
        children: "turbo"
      }), " 버전을 찾기 위해 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 현재 디렉토리에서 항상 위쪽으로 몇 가지 단계를 거칩니다:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "가장 가까운 turbo.json을 찾습니다."
      }), "\n", _jsxs(_components.li, {
        children: ["찾지 못하면 ", _jsx(_components.code, {
          children: "workspaces"
        }), " 속성이 있는 첫 번째 ", _jsx(_components.code, {
          children: "package.json"
        }), "을 찾습니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["찾지 못하면 첫 번째 ", _jsx(_components.code, {
          children: "package.json"
        }), "을 찾습니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["전역으로 설치된 ", _jsx(_components.code, {
        children: "turbo"
      }), " 버전은 로컬로 설치된 ", _jsx(_components.code, {
        children: "turbo"
      }), " 버전이 존재하지 않거나 찾을 수 없는 경우에만 사용됩니다."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "turbo-inference",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo --version"
      }), " 및 ", _jsx(_components.code, {
        children: "turbo bin"
      }), "은 작업을 실행할 ", _jsx(_components.code, {
        children: "turbo"
      }), " 사본의 버전과 바이너리 위치를 각각 표시합니다.\n또한 ", _jsx(_components.code, {
        children: "-vv"
      }), " 또는 ", _jsx(_components.code, {
        children: "--verbosity=2"
      }), "로 실행하면 로컬 또는 전역 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 사용되는지 항상 표시됩니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --version"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --verbosity=2"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "2023-01-11T10:49:04.042-0500"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [DEBUG] turborepo_lib::shim: No "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "local"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " turbo binary found at: /Users/knickman/Developer/vercel/my-awesome-monorepo/node_modules/.bin/turbo"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "2023-01-11T10:49:04.042-0500"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [DEBUG] turborepo_lib::shim: Running command as global turbo"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "1.7.0"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h2, {
      id: "명확성-향상을-위해-outputs-선언",
      children: ["명확성 향상을 위해 ", _jsx(_components.code, {
        children: "outputs"
      }), " 선언"]
    }), "\n", _jsxs(_components.p, {
      children: ["이전에는 작업에 대한 ", _jsx(_components.code, {
        children: "outputs"
      }), " 키를 지정하지 않으면 Turborepo가 자동으로 ", _jsx(_components.code, {
        children: "dist/"
      }), " 및 ", _jsx(_components.code, {
        children: "build/"
      }), " 디렉토리의 모든 파일을 캐시하려고 시도했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이는 특정 프레임워크의 ", _jsx(_components.code, {
        children: "build"
      }), " 작업에는 잘 작동했지만 이 암시적 동작은 ", _jsx(_components.em, {
        children: "모든"
      }), " 작업에 적용되므로 잘 확장되지 않았습니다. Turborepo를 사용하는 많은 개발자, 팀, 프로젝트 및 코드베이스에서 ", _jsx(_components.code, {
        children: "dist/"
      }), " 및 ", _jsx(_components.code, {
        children: "build/"
      }), " 디렉토리를 자동으로 캐시하는 가정이 사용자에게 문제를 일으키고 있다는 것을 발견했습니다."]
    }), "\n", _jsx(_components.p, {
      children: "버전 1.7에서는 이 동작이 제거되었으며 이제 turborepo에 캐시할 내용을 명시적으로 알려야 합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+     \"outputs\": [\"dist/**\", \"build/**\"]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["1.7 미만 버전의 Turborepo에서 기본 캐시 출력에 의존하고 있었다면 ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#set-default-outputs",
        children: _jsx(_components.code, {
          children: "@turbo/codemod set-default-outputs"
        })
      }), " codemod를 실행하여 동일한 동작을 얻을 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " set-default-outputs"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["또한 아무것도 캐시하지 않는 것이 이제 기본 동작이므로 더 이상 ", _jsx(_components.code, {
        children: "outputs: []"
      }), "를 지정할 필요가 없습니다. codemod는 작업에서 이 구성도 제거합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "더-조용한-로그를-위한-오류만-출력-모드",
      children: "더 조용한 로그를 위한 \"오류만\" 출력 모드"
    }), "\n", _jsxs(_components.p, {
      children: ["오류에 대한 가시성을 제공하기 위해 커뮤니티 멤버 ", _jsx(_components.a, {
        href: "https://github.com/dobesv",
        children: "@dobesv"
      }), "가 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/pull/2588",
        children: "작업 실행의 모든 로그 대신 오류만 표시하는 솔루션"
      }), "을 기여했습니다. 파이프라인을 디버깅하는 동안 ", _jsx(_components.code, {
        children: "--output-logs=errors-only"
      }), "를 사용하여 신호 대 잡음비를 높게 유지하여 파이프라인의 성공적인 실행을 보장하는 데 집중할 수 있습니다.\n이는 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: "구성 옵션"
      }), " 또는 ", _jsx(_components.a, {
        href: "/docs/reference/run#--output-logs-option",
        children: "CLI 플래그"
      }), "로 사용할 수 있습니다"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --output-logs=errors-only"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-6-0",
        children: "Turborepo v1.6"
      }), "을 출시하고 ", _jsx(_components.a, {
        href: "https://turborepo.com/pack",
        children: "Turbopack"
      }), "과 병합한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "18.7k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "주간 NPM 다운로드 750k"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel의 Remote Caching"
        }), "을 통해 30년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
